export default "__VITE_ASSET__CcwuCO1E__"